import React, { Component ,lazy,Suspense} from "react";
// import { useNavigate } from 'react-router-dom';
// import { withStyles } from "@material-ui/core/styles";
// import { withStyles } from "@mui/styles";
import { Route, Switch } from "react-router-dom";
import path from "../utils/constant/path";
import { withRouter } from "react-router";
// import Login from "../container/login/login";
import Navbar from '../components/Navbar/Navbar'
import Spinner from '../components/Spinner/Spinner'
import SuccessTransact from "../components/Transaction/SuccessTransaction";
import CardDetails from "../components/Transaction/CardDetails";

import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { PersistGate } from 'redux-persist/integration/react'
import { encryptTransform } from 'redux-persist-transform-encrypt';
import reducer from "../redux/reducer/index";
const styles = (theme) => ({
  grid: {
    display: "grid",
    gridTemplateColumns: "15% 85%",
  },
});
const enhancers = [applyMiddleware(thunk)];
const composeEnhancers = process.env.NODE_ENV !== 'production'
  && typeof window === 'object'
  && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    shouldHotReload: false
  })
  : compose;
const persistConfig = {
  key: 'root',
  transforms: [
    encryptTransform({
      secretKey:"Cyber",
      onError: function (error) {
        // Handle the error.
      },
    }),
  ],
  storage,
}

const persistedReducer = persistReducer(persistConfig, reducer)

const store = createStore(persistedReducer, composeEnhancers(...enhancers))
const Cart = lazy(() => import("../pages/CartContent/CartItems"));
const Productlist = lazy(() => import("../pages/Products/ProductList"));

const ProductDetails = lazy(() =>
  import("../pages/SingleProduct/SingleProduct")
);

class ZRouter extends Component {
  constructor(props) {
    super();
    this.state = {};
  }
  componentDidMount() {}

  render() {
   
    let persist = persistStore(store)
    const { classes } = this.props;
    return (
      <>
        {/* <Provider store={store}> */}
        <Provider store={store}>
        <div>
        <Navbar />

        <PersistGate loading={null} persistor={persist}>
           {/* <PermanentDrawerLeft> */}
           <Suspense fallback={<Spinner />}>
        <Switch>
          {/* <Route exact path="/" component={Homepage}></Route> */}
          <Route  path={path.Cart} component={Cart}></Route>
          <Route exact path={path.ProductList} component={Productlist}></Route>
          <Route  path={path.CardDetails} component={CardDetails}></Route>
          <Route  path={path.SuccessTransact} component={SuccessTransact}></Route>
          <Route
            exact
            path={path.Product}
            children={<ProductDetails />}
          ></Route>
          {/* <Route exact path="*" component={Errorpage}></Route> */}
        </Switch>
      </Suspense>
              {/* </PermanentDrawerLeft> */}
              </PersistGate>
            </div>
            </Provider>
        {/* </Provider> */}
      </>
    );
  }
}
export default withRouter(ZRouter);
